import { AbstractFormComponent } from '@df/ui/form/abstract-form.component';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { Directive } from '@angular/core';
@Directive()
export abstract class GiftcardsBalanceFormComponentDef extends AbstractFormComponent<Giftcards.IBalanceCheckData> {
    submitPath = Giftcards.Endpoints.Balance;

    balance: number | undefined;

    override reset() {
        this.balance = undefined;
        super.reset();
    }

    get hasBalance(): boolean {
        return this.balance !== undefined;
    }

    override submit() {
        this.balance = undefined;
        super.submit();
    }

    protected override onSubmitSuccess(response?: Giftcards.IBalanceCheckResponse) {
        super.onSubmitSuccess(response);
        this.balance = response && response.balance;
    }
}
